import React from 'react';
import { SECONDARY_BUTTON_HOVER_SX, StyledButton } from '../../styles/StyledButtons';

interface AddFootnoteToolbarButtonProps {
  open: boolean;
  onClick: () => void;
}

/** A block's toolbar control for showing/hiding its Footnotes panel. */
export default function AddFootnoteToolbarButton({ open, onClick }: AddFootnoteToolbarButtonProps) {
  return (
    <StyledButton
      compact
      noTopSpacing
      buttonVariant="inactiveOrCancel"
      sx={SECONDARY_BUTTON_HOVER_SX}
      onClick={onClick}
      aria-pressed={open}
    >
      Footnote
    </StyledButton>
  );
}
